var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClockFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon clock full"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 21C9 14.37 14.373 9 21 9C27.627 9 33 14.37 33 21C33 27.63 27.627 33 21 33C20.448 33 20 33.45 20 34C20 34.55 20.448 35 21 35C28.732 35 35 28.73 35 21C35 13.27 28.732 7 21 7C13.268 7 7 13.27 7 21C7 21.55 7.448 22 8 22C8.552 22 9 21.55 9 21Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.6399 23.77C22.8679 23.58 22.9999 23.3 22.9999 23V14C22.9999 13.45 22.5519 13 21.9999 13C21.4479 13 20.9999 13.45 20.9999 14V22.53L15.3599 27.23C14.9359 27.59 14.8779 28.22 15.2319 28.64C15.5849 29.06 16.2159 29.12 16.6399 28.77L22.6399 23.77Z",
    fill: "black",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockFilled);
export default __webpack_public_path__ + "static/media/icon-clock-filled.c5e16f50c182deb4b6abda8c153498eb.svg";
export { ForwardRef as ReactComponent };